import {
  PanTool,
  ZoomTool,
  WindowLevelTool,
  LengthTool,
  AngleTool,
  PlanarFreehandROITool,
} from '@cornerstonejs/tools';
import { SPECTRAL_DOPPLER_TOOL_NAMES } from '@/features/study-detail/Viewer/tools/SpectralDoppler';
import { SIMPSON_TOOL_NAME } from '@/utils/measurementToolMapping';
import styles from './ToolHint.module.css';

// Doppler hints sit at the top, off the strip being traced.
const SPECTRAL_TOOLS = new Set<string>(
  Object.values(SPECTRAL_DOPPLER_TOOL_NAMES)
);

interface ToolHintProps {
  activeTool: string | undefined;
}

const TOOL_HINTS: Record<string, { gesture: string; label: string }> = {
  [PanTool.toolName]: {
    gesture: 'Click and drag',
    label: 'to pan the image',
  },
  [ZoomTool.toolName]: {
    gesture: 'Click and drag',
    label: 'to zoom',
  },
  [WindowLevelTool.toolName]: {
    gesture: 'Click and drag',
    label: 'to adjust window / level',
  },
  [LengthTool.toolName]: {
    gesture: 'Click two points',
    label: 'to measure length',
  },
  [AngleTool.toolName]: {
    gesture: 'Click three points',
    label: 'to measure an angle',
  },
  [PlanarFreehandROITool.toolName]: {
    gesture: 'Click and drag',
    label: 'to trace an area',
  },
  [SIMPSON_TOOL_NAME]: {
    gesture: 'Click and drag',
    label: 'to trace a volume',
  },
  [SPECTRAL_DOPPLER_TOOL_NAMES.PROBE]: {
    gesture: 'Click',
    label: 'to measure velocity at a point',
  },
  [SPECTRAL_DOPPLER_TOOL_NAMES.SEGMENT]: {
    gesture: 'Click and drag',
    label: 'to measure a segment',
  },
  [SPECTRAL_DOPPLER_TOOL_NAMES.VTI]: {
    gesture: 'Click and drag',
    label: 'to trace the envelope',
  },
};

export function ToolHint({ activeTool }: ToolHintProps) {
  if (!activeTool) return null;
  const hint = TOOL_HINTS[activeTool];
  if (!hint) return null;
  return (
    <div
      className={styles.toolHint}
      data-placement={SPECTRAL_TOOLS.has(activeTool) ? 'top' : undefined}
      role="status"
      aria-live="polite"
    >
      <span className={styles.gesture}>{hint.gesture}</span>
      <span>{hint.label}</span>
    </div>
  );
}
